<template>
  <div>
    <DialogBase
      v-model="inputedValue"
      :title="$t('order.order_input-from-out-of-stock-products')"
      width="800px"
      :isFooter="true"
      :isPadding0="true"
    >
      <v-container fluid class="baseStyle pa-0">
        <v-row no-gutters class="ma-7">
          <v-col>
            <div class="yCenter">
              <div class="titleStyle">
                {{ $t('common.input_supplier-name') }}
              </div>
              <div class="original-selectbox selectBoxStyle pr-3">
                <NormalCombobox
                  v-model="localSelectClientName"
                  :items="comboboxList"
                  height="32px"
                />
              </div>
              <div class="selectStorageStyle">
                <SelectStorageName v-model="selectStorege" />
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-2">
          <v-col cols="12">
            <div class="Com">
              <v-data-table
                :headers="getTableHeaders"
                :items="tableData.items"
                :item-key="tableData.itemKey"
                hide-default-footer
                :no-data-text="$t('storage.storage_not-products-out-of-stock')"
                :items-per-page="-1"
              >
                <template v-slot:[`header.checkBox`]>
                  <v-checkbox v-model="allCheck"> </v-checkbox>
                </template>
                <template v-slot:[`item.checkBox`]="{ item }">
                  <v-checkbox v-model="item.checkFlg" class="checkBoxCenter">
                  </v-checkbox>
                </template>
                <template v-slot:[`item.productName`]="{ item }">
                  {{ item.nameJp }} <br />
                  {{ item.nameCn }}
                </template>
                <template v-slot:[`item.capacity`]="{ item }">
                  {{ item.capacity ? item.capacity : '-' }}
                </template>
                <template v-slot:[`item.lack`]="{ item }">
                  {{ item.lack }}
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <template #footer>
        <v-spacer> </v-spacer>
        <div class="btnStyle pt-3 pb-2">
          <NormalButton
            :text="$t('common.input_reflect')"
            textSize="16px"
            height="50px"
            width="100%"
            :disabled="isBtnDisabled"
            @click="reflect()"
          />
        </div>
      </template>
    </DialogBase>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DialogBase from '@/components/layouts/Dialogs/DialogBase'
import {
  NormalButton,
  NormalCombobox,
  SelectStorageName
} from '@/components/items'
import { currencyUtil, supplierUtil } from '@/util'
import { viewConfig } from '@/config'

export default {
  components: {
    DialogBase,
    NormalButton,
    NormalCombobox,
    SelectStorageName
  },
  props: {
    value: {
      type: Boolean,
      require: true,
      default: false
    },
    // dialog: { default: false },
    target: { default: '' },
    selectClientName: {
      type: Object,
      require: true,
      default: () => ({ label: '', value: null })
    }
  },
  data: () => ({
    radioGroup: '',
    itemsPerPage: viewConfig.DATA_TABLE.ITEMS_PER_PAGE_DEFAULT,
    comboboxList: [],
    allCheck: false,

    localSelectClientName: { label: '', value: null },
    selectStorege: {},
    productList: [],
    tableData: {
      itemKey: 'productId',
      items: []
    }
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductAndStockListFromApi']),
    ...mapGetters('Supplier', ['getSupplierIdNameAndDescriptionListFromState']),
    async init() {
      await supplierUtil.getSupplier()
      this.comboboxList = this.getSupplierIdNameAndDescriptionListFromState()
      if (this.comboboxList.length > 0)
        this.localSelectClientName = this.comboboxList[0]
    },
    async setProductList() {
      if (!this.localSelectClientName) return
      const productList = await this.getProductAndStockListFromApi({
        supplierId: this.localSelectClientName.value
      })
      this.productList = productList.data
    },
    setDisplayProductList() {
      this.tableData.items = this.productList
        .map((product) => {
          const stock = this.getProductOrverOrShortStock(product)
          return {
            checkFlg: false,
            productId: product.productId,
            productNumber: product.productNumber,
            nameJp: product.nameJp,
            nameCn: product.nameCn,
            capacity: product.capacity,
            lack: stock
          }
        })
        .filter((ele) => ele.lack < 0)
    },
    getProductOrverOrShortStock(product) {
      const productStockQuantityForStorage =
        product.productStockQuantityInfo.find(
          (ele) => ele.storageId == this.selectStorege.value
        )
      const productMovingQuantityForStorage =
        product.productMovingQuantityInfo.find(
          (ele) => ele.storageId == this.selectStorege.value
        )
      const orderProductPlanQuantity = this.getProductQuantity(
        product.productPlanQuantityInfo,
        2
      )
      const salesProductPlanQuantity = this.getProductQuantity(
        product.productPlanQuantityInfo,
        1
      )

      const stockQuantity = productStockQuantityForStorage
        ? productStockQuantityForStorage.quantity
        : 0
      const MovingQuantity = productMovingQuantityForStorage
        ? productMovingQuantityForStorage.quantity
        : 0

      return (
        stockQuantity +
        MovingQuantity +
        orderProductPlanQuantity +
        salesProductPlanQuantity
      )
    },
    // TODO: Utilに共通化、transactionTypeの定数化
    getProductQuantity(productQuantity, transactionType) {
      const ret = productQuantity.reduce((result, current) => {
        if (
          !transactionType ||
          Number(current.transactionType) === transactionType
        ) {
          return result + current.quantity
        }
        return result
      }, 0)
      return ret
    },
    reflect() {
      const productResponseData = this.tableData.items.filter(
        (ele) => ele.checkFlg
      )
      this.$emit('reflect', this.localSelectClientName, productResponseData)
      this.inputedValue = false
    }
  },
  computed: {
    getTableHeaders() {
      return [
        {
          value: 'checkBox',
          width: '55px',
          sortable: false,
          align: 'center'
        },
        {
          text: this.$t('product.product_product-number'),
          value: 'productNumber',
          width: '135px',
          align: 'center'
        },
        {
          text: this.$t('common.product_product-name'),
          value: 'productName',
          width: '390px'
        },
        {
          text: this.$t('common.product_capacity'),
          value: 'capacity',
          width: '90px',
          align: 'center'
        },

        {
          text: this.$t('order.order_shortage'),
          value: 'lack',
          width: '120px',
          align: 'center'
        }
      ]
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    isBtnDisabled() {
      const checkedList = this.tableData.items.filter((ele) => ele.checkFlg)
      return checkedList.length <= 0
    }
  },
  watch: {
    localSelectClientName: {
      deep: true,
      async handler(newVal, oldVal) {
        await this.setProductList()
        this.setDisplayProductList()
      }
    },
    selectStorege: {
      deep: true,
      async handler(newVal, oldVal) {
        await this.setProductList()
        this.setDisplayProductList()
      }
    },
    allCheck(newVal) {
      this.tableData.items.map((ele) => (ele.checkFlg = newVal))
    }
  }
}
</script>
<style lang="scss" scoped>
.baseStyle {
  font-size: 14px;
}
#original-expansion-panel::v-deep .v-expansion-panel::before {
  box-shadow: none;
}

.titleStyle {
  font-size: 15px;
  font-weight: bold;
}
.selectBoxStyle {
  width: 340px;
  margin-left: 17px !important;
  // margin: 0px 10px 0px 63px !important;
}
.btnStyle {
  width: 130px;
}
.selectStorageStyle {
  width: 150px;
}

.Com {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    // padding: 0px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;

    border: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;

    border: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    padding: 0px 5px !important;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: #fff;
    border-collapse: collapse;

    border: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    padding: 0px 5px !important;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  .tdStyleCenter {
    text-align: center !important;
  }
  .DisplayNone {
    display: none;
  }
  .checkBoxCenter ::v-deep .v-input__slot {
    justify-content: center;
  }
}
</style>
